import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Legal from "@/pages/Legal";
import Riflessioni from "@/pages/Riflessioni";
import Articolo from "@/pages/Articolo";
import { setLenis, scrollToTop } from "@/lib/scroll";

const ScrollReset = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        scrollToTop();
    }, [pathname]);
    return null;
};

function App() {
    useEffect(() => {
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        setLenis(lenis);
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            setLenis(null);
        };
    }, []);

    return (
        <BrowserRouter>
            <ScrollReset />
            <Toaster position="top-center" richColors />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/riflessioni" element={<Riflessioni />} />
                <Route path="/riflessioni/:slug" element={<Articolo />} />
                <Route path="/privacy-policy" element={<Legal type="privacy" />} />
                <Route path="/cookie-policy" element={<Legal type="cookie" />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
